/* eslint-disable no-return-await */
import _ from 'underscore';
import { DataSourceState } from '@bingads-webui-react/image-picker';
import SocialMediaRepository from '../../util/social-media-repository';

export interface IImageItem {
  id: number;
  src: string;
  altText: string;
  textFields: string[];
  width?: number;
  height?: number;
}

export enum FetchImageResult {
  Done = 'Done',
  NoAccountFound = 'NoAccountFound',
  NoImagesFound = 'NoImagesFound',
}

interface IDataSource {
  subscribe: (cb: (...args: any[]) => void) => void;
  unsubscribe: (...args: any[]) => void;
  getData: () => {data: IImageItem[], hasMore: boolean}
}

interface IOptions {
  repository: SocialMediaRepository;
}

export default class SocialMediaDataSource implements IDataSource {
  callback: any;
  data: IImageItem[];
  repository: SocialMediaRepository;
  socialMediaAccounts: {Key: string, Value: string}[];

  constructor(options: IOptions) {
    this.repository = options.repository;
    this.data = [];
    this.socialMediaAccounts = [];
  }

  subscribe(callback: (...args: any[]) => void) {
    this.callback = callback;
  }

  unsubscribe() {
    this.callback = null;
  }

  reset() {
    this.data = [];

    this.excuteCallBackIfExsit(DataSourceState.Done);
  }

  // Loading, Done, Error
  excuteCallBackIfExsit(status: string) {
    if (this.callback) {
      this.callback(status);
    }
  }

  async fetchImageByAccount(socialMediaAccounts: {Key: string, Value: string}[]) {
    this.excuteCallBackIfExsit(DataSourceState.Loading);
    const { SocialMediaImages } = await this.repository.getSocialMediaImages(socialMediaAccounts);

    if (SocialMediaImages.length === 0) {
      this.excuteCallBackIfExsit(DataSourceState.Done);
      return FetchImageResult.NoImagesFound;
    }

    this.data = SocialMediaImages[0].Value.map(d => ({
      id: parseInt(_.uniqueId(), 10),
      src: d.Url,
      width: d.Width,
      height: d.Height,
      textFields: [],
      altText: '',
    }));
    this.excuteCallBackIfExsit(DataSourceState.Done);
    return FetchImageResult.Done;
  }

  async fetchImages(url: string): Promise<FetchImageResult> {
    this.excuteCallBackIfExsit(DataSourceState.Loading);

    const { SocialMediaAccounts } = await this.repository.getSocialMediaAccounts(url);
    if (SocialMediaAccounts.length === 0) {
      this.excuteCallBackIfExsit(DataSourceState.Done);
      return FetchImageResult.NoAccountFound;
    }

    this.socialMediaAccounts = SocialMediaAccounts;
    return await this.fetchImageByAccount(SocialMediaAccounts);
  }

  getData() {
    return { hasMore: false, data: this.data };
  }
}
